import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFullScreenExit = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9 21H7v-2.6l-3.1 3.1-1.4-1.4L5.6 17H3v-2h6zm12-4h-2.6l3.1 3.1-1.4 1.4-3.1-3.1V21h-2v-6h6zM7 5.6V3h2v6H3V7h2.6L2.5 3.9l1.4-1.4zm14.5-1.7L18.4 7H21v2h-6V3h2v2.6l3.1-3.1z" })
});
export default SvgFullScreenExit;
